import Module from '../../module';
import scroll from '../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			aboutAboutHeliumAirshipsContentSectionHeaderCls: string;
			aboutAboutHeliumAirshipsContentSectionSubheaderCustomCls: string;
			aboutAboutHeliumAirshipsContentSectionTextInnerCls: string;
		}
	},

	slug: string
}

class Airships extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('About About Helium Airships Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumAirshipsContentSectionHeaderCls || '','about_about_helium_airships', { animCls: 'animate__fadeInLeft25P', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumAirshipsContentSectionSubheaderCustomCls || '','about_about_helium_airships', { animCls: 'animate__fadeInDown', once: true});
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.aboutAboutHeliumAirshipsContentSectionTextInnerCls || '','about_about_helium_airships', { animCls: 'animate__fadeInRight25P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Airships;